export default __webpack_public_path__ + "static/media/PressRelease.e8f81e75.zip";